export const SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
export const PUBLIC_URL = process.env.REACT_APP_API_PUBLIC_URL;
export const FIREBASE_CONFIG = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
	databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
};
export const SEGMENT_IO_ANALYTICS_KEY = process.env.REACT_APP_SEGMENT_IO_KEY || "";

export const OrderStatuses = {
	CREATED: "CREATED",
	IN_QUEUE: "IN_QUEUE",
	IN_PROGRESS: "IN_PROGRESS",
	PARTIALLY_COMPLETED: "PARTIALLY_COMPLETED",
	COMPLETED: "COMPLETED",
	CANCELLED: "CANCELLED",
	FAILED: "FAILED",
	ABORTED: "ABORTED",
};

export const TaskStatuses = {
	ORDERED: "ORDERED",
	IN_QUEUE: "IN_QUEUE",
	IN_PROGRESS: "IN_PROGRESS",
	PREPARED: "PREPARED",
	READY_TO_COLLECT: "READY_TO_COLLECT",
	COLLECT_INITIATED: "COLLECT_INITIATED",
	COLLECTING: "COLLECTING",
	SERVED: "SERVED",
	DISCARD_INITIATED: "DISCARD_INITIATED",
	DISCARDING: "DISCARDING",
	DISCARDED: "DISCARDED",
	DISCARD_FAILED: "DISCARD_FAILED",
	DISCARD_ABORTED: "DISCARD_ABORTED",
	ABORTED: "ABORTED",
	FAILED: "FAILED",
};

export const PaymentStatus = {
	PAYMENT_PENDING: "PAYMENT_PENDING",
	PAYMENT_SUCCESSFUL: "PAYMENT_SUCCESSFUL",
	PAYMENT_FAILED: "PAYMENT_FAILED",
	REFUND_INITIATED: "REFUND_INITIATED",
	REFUND_PROCESSED: "REFUND_PROCESSED",
	REFUND_FAILED: "REFUND_FAILED",
	REFUND_REQUESTED: "REFUND_REQUESTED",
	REFUND_NOT_APPLICABLE: "REFUND_NOT_APPLICABLE"
};

export const CollectQueueStatus = {
	QUEUED: "QUEUED", // a collect task is waiting behind another collect 
	OPEN: "OPEN", // alternative to "READY" — meaning it's clear to collect
	COLLECTING: "COLLECTING" // collection in progress 
};

export const orderStatusMap: any = {
	[OrderStatuses.CREATED]: {
		statusMessage: "IN QUEUE",
		color: "#FFBE82",
	},
	[OrderStatuses.IN_QUEUE]: {
		statusMessage: "IN QUEUE",
		color: "#FFBE82",
		track: true,
	},
	[OrderStatuses.IN_PROGRESS]: {
		statusMessage: "IN PROGRESS",
		color: "#45FF27",
		track: true,
	},

	//NOTE : This is a very temporary change. Please Revert this back ASAP.

	[OrderStatuses.PARTIALLY_COMPLETED]: {
		statusMessage: "COMPLETED",
		color: "#A5FFFA",
	},
	[OrderStatuses.COMPLETED]: {
		statusMessage: "COMPLETED",
		color: "#A5FFFA",
	},
	[OrderStatuses.CANCELLED]: {
		statusMessage: "CANCELLED",
		color: "#FF7F6E",
	},
	[OrderStatuses.ABORTED]: {
		statusMessage: "ABORTED",
		color: "#FC5039",
	},
	[OrderStatuses.FAILED]: {
		statusMessage: "FAILED",
		color: "#FF7F6E",
	},
};

export const taskStatusMap: any = {
	[TaskStatuses.ORDERED]: {
		statusMessage: "IN QUEUE",
		showETA: true,
		color: "#FFBE82",
	},
	[TaskStatuses.IN_QUEUE]: {
		statusMessage: "IN QUEUE",
		showETA: true,
		color: "#FFBE82",
	},
	[TaskStatuses.IN_PROGRESS]: {
		statusMessage: "PREPARING",
		showETA: false,
		color: "#45FF27",
	},
	[TaskStatuses.PREPARED]: {
		statusMessage: "PREPARING",
		showETA: false,
		color: "#45FF27",
	},
	[TaskStatuses.READY_TO_COLLECT]: {
		statusMessage: "PREPARED",
		color: "#8AFF77",
	},
	[TaskStatuses.COLLECT_INITIATED]: {
		statusMessage: "FETCHING SHORTLY",
		color: "#FFF177",
	},
	[TaskStatuses.COLLECTING]: {
		statusMessage: "COLLECTING",
		color: "#47E9FF",
	},
	[TaskStatuses.SERVED]: {
		statusMessage: "SERVED",
		color: "#8F9AFF",
	},
	[TaskStatuses.DISCARDING]: {
		statusMessage: "DISCARDED",
		color: "#FF7F6E",
	},
	[TaskStatuses.DISCARD_INITIATED]: {
		statusMessage: "DISCARDED",
		color: "#FF7F6E",
	},
	[TaskStatuses.DISCARDED]: {
		statusMessage: "DISCARDED",
		color: "#FF7F6E",
	},
	[TaskStatuses.DISCARD_FAILED]: {
		statusMessage: "DISCARDED",
		color: "#FF7F6E",
	},
	[TaskStatuses.DISCARD_ABORTED]: {
		statusMessage: "DISCARDED",
		color: "#FF7F6E",
	},
	[TaskStatuses.ABORTED]: {
		statusMessage: "ABORTED",
		color: "#FF7F6E",
	},
	[TaskStatuses.FAILED]: {
		statusMessage: "FAILED",
		color: "#FF7F6E",
	},
};

export const PaymentStatusMap = {
	[PaymentStatus.PAYMENT_PENDING]: {
		head: "Payment Pending",
		desc: "",
		shortDesc: "",
		keyToRead: "",
		isVisible: false,
	},
	[PaymentStatus.PAYMENT_SUCCESSFUL]: {
		head: "Payment Successful",
		desc: "",
		shortDesc: "",
		keyToRead: "amountPaid",
		isVisible: false,
	},
	[PaymentStatus.PAYMENT_FAILED]: {
		head: "Payment Failed",
		desc: "",
		shortDesc: "",
		keyToRead: "",
		isVisible: false,
	},
	[PaymentStatus.REFUND_INITIATED]: {
		head: "Refund Initiated",
		desc: "",
		shortDesc: "Refund initiated for amount ",
		keyToRead: "",
		isVisible: true,
	},
	[PaymentStatus.REFUND_PROCESSED]: {
		head: "Refund Processed",
		desc: "",
		shortDesc: "Refund has been processed ",
		keyToRead: "amountRefunded",
		isVisible: true,
	},
	[PaymentStatus.REFUND_FAILED]: {
		head: "Refund Failed",
		desc: "",
		shortDesc: "Refund failed for amount ",
		keyToRead: "",
		isVisible: true,
	},
	[PaymentStatus.REFUND_REQUESTED]: {
		head: "Refund Requested",
		desc: "",
		shortDesc: "Refund requested for amount ",
		keyToRead: "amountPaid",
		isVisible: true,
	},
	[PaymentStatus.REFUND_NOT_APPLICABLE]: {
		head: "",
		desc: "",
		shortDesc: "",
		keyToRead: "",
		isVisible: false,
	},
};
